import graphql__459aa89d4ec86020331d from "./__generated__/viewer_viewer.graphql.js";
import graphql__c76eb69522f50a024d28 from "./__generated__/viewerQuery.graphql.js";import { fetchQuery } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../../config/AppRelayEnvironment";

//
// Action types
//

export const SET_VIEWER = "SET_VIEWER";
export const UPDATE_VIEWER = "UPDATE_VIEWER";

//
// Action creators
//

export function setViewer(viewer) {
  return {
    type: SET_VIEWER,
    viewer
  };
}

export function updateViewer(viewer) {
  return {
    type: UPDATE_VIEWER,
    viewer
  };
}

export const viewerFragment = graphql__459aa89d4ec86020331d;

const loadViewerQuery = graphql__c76eb69522f50a024d28;

export function loadViewer() {
  const environment = appRelayEnvironment;

  return dispatch => {
    return fetchQuery(environment, loadViewerQuery).subscribe({
      next: ({ viewer }) => dispatch(setViewer(viewer))
    });
  };
}

function setViewerHandler(viewer) {
  return viewer;
}

function updateViewerHandler(state, viewer) {
  return { ...state, ...viewer };
}

//
// Reducer and handlers
//
export default function viewerReducer(state, action) {
  switch (action && action.type) {
    case SET_VIEWER:
      return setViewerHandler(action.viewer);

    case UPDATE_VIEWER:
      return updateViewerHandler(state, action.viewer);

    default:
      return state || {};
  }
}
